import { Emitter } from '@/lib/emitter'

export type Events = {
  signedIn: () => void
  signedOut: () => void
}

export const appEvents = new Emitter<Events>()

export const onSignedIn = appEvents.makeListener('signedIn')
export const onSignedOut = appEvents.makeListener('signedOut')
